import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { useFormik } from "formik";
import { Link } from "react_reusable_components";
import { ArrowLeftOutlined } from "@ant-design/icons";

import Button from "../../components/Button";
import CustomInput from "../../components/CustomInput/CustomInput";
import { TwoRow } from "../../core/layouts";

import {
  forgotPasswordEmailFieldNames,
  forgotPasswordEmailValidationSchema,
  forgotPasswordEmailInitialValues,
} from "../../validationSchema";
import variables from "../../themes/base/styles/variables";
import { AuthService } from "../../services";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";

const ForgotPasswordStyle = {
  sectionsStyle: { marginBottom: variables.marginLarge },
  bottomSectionStyle: {
    marginTop: variables.marginXLarge,
  },
  backToLogin: {
    marginTop: variables.marginMediumLarge,
    fontSize: variables.fontSizeNormal,
    lineHeight: variables.lineHeightLarge,
  },
};

const ForgotPassword = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const [disabled, setDisabled] = useState(false);

  const { values, handleBlur, handleChange, handleSubmit, errors } = useFormik({
    initialValues: forgotPasswordEmailInitialValues,
    onSubmit: async function (data) {
      setDisabled(true);
      try {
        await AuthService.forgotPassword(data, intl);
        setDisabled(false);
      } catch (err) {
        setDisabled(false);
      } finally {
        setDisabled(false);
      }
    },
    validationSchema: forgotPasswordEmailValidationSchema(intl),
  });

  function backToLogin() {
    navigate("/login");
  }

  return (
    <TwoRow
      topSection={
        <CustomInput
          placeholder={getLocalizedMessage(intl, "login.placeholder.email")}
          label={getLocalizedMessage(intl, "login.label.email")}
          error={errors[forgotPasswordEmailFieldNames.EMAIL]}
          value={values[forgotPasswordEmailFieldNames.EMAIL]}
          onChange={handleChange}
          onBlur={handleBlur}
          required
          name={forgotPasswordEmailFieldNames.EMAIL}
        />
      }
      bottomSection={
        <TwoRow
          topSection={
            <Button disabled={disabled} onClick={handleSubmit}>
              {getLocalizedMessage(intl, "login.button.resetPassword")}
            </Button>
          }
          bottomSection={
            <Link
              href="#"
              style={ForgotPasswordStyle.backToLogin}
              onClick={backToLogin}
            >
              <ArrowLeftOutlined />{" "}
              {getLocalizedMessage(intl, "login.backToLogin")}
            </Link>
          }
          bottomSectionStyle={{
            justifyContent: "center",
          }}
        />
      }
      topSectionStyle={ForgotPasswordStyle.sectionsStyle}
      bottomSectionStyle={ForgotPasswordStyle.bottomSectionStyle}
    />
  );
};

export default ForgotPassword;
